<template>
	<div class="sitewrapper">
		<component
			:is="CurrentComponent"
			v-bind="router.props"
			class="AppContainer"
		/>
	</div>
</template>

<script src="./app.ts"></script>
<style lang="scss" src="./app.scss"></style>
